import { connect } from 'react-redux'

import { selectAction, searchChangedAction, searchResultsArrived, changeShowFiltersAction,
  waitForServerAction } from './actions'
import SearchComponent from './SearchComponent'

const mapStateToProps = state => {
  return {
    places: state.places,
    selected: state.selected,
    query: state.query,
    searchResults: state.searchResults,
    isWaitingForResponse: state.isWaitingForResponse,
    showingFilters: state.showingFilters,
    filteredResults: state.filteredResults,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSelectClick: selected => dispatch(selectAction(selected)),
    onSearchChanged: value => dispatch(searchChangedAction(value)),
    onSearchResults: results => dispatch(searchResultsArrived(results)),
    changeShowFilters: show => dispatch(changeShowFiltersAction(show)),
    waitingForResponse: status => dispatch(waitForServerAction(status)),
  }
}

const SearchContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchComponent)

export default SearchContainer



// WEBPACK FOOTER //
// ./src/SearchContainer.js